
import BtnStartStop from "../../RsCommands/BtnStartStop/BtnStartStop";
import Indicator from "../../../UI/Indicator/Indicator";
import './PumpPlc.css';

export default function PumpPlc({
        pumpNumber, 
        mode,
        status, 
        speed, 
        current,
        commError,
        pressureAlarm,
        dryRun,
        flowError,
        driveFault,
        faultDetails
    }) 
{
    return (
        <div className="pump-body"> 
        <table className="status-table">
        <thead>
            <tr>
                <th colspan="2" className="table-header">Насос №{pumpNumber}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className="first-col">Режим работы</td>
                <td className="second-col">{mode}</td>
            </tr>
            <tr>
                <td className="first-col">Состояние</td>
                <td className={`second-col ${status==='Авария'? ("statusPlcNA-error") :
                 (status==='В работе') ? ("statusPlcNA-active"):("statusPlcNA-warning")} `}>{status}</td>
            </tr>
            <tr>
                <td className="first-col">Скорость НА</td>
                <td className="second-col">{speed}</td>
            </tr>
            <tr>
                <td className="first-col">Ток</td>
                <td className="second-col">{current}</td>
            </tr>
            <tr className="indicator-row">
                <td className="first-col">
                    <div className="indicator-container">
                        <Indicator state={commError ? 'on' : 'off'} />
                        Отсутствие связи с ПЧ
                    </div>
                </td>
                <td className="second-col">
                    <div className="indicator-container">
                        <Indicator state={pressureAlarm ? 'on' : 'off'} />
                        Аварийное давление
                    </div>
                </td>
            </tr>
            <tr className="indicator-row">
                <td className="first-col">
                    <div className="indicator-container">
                        <Indicator state={dryRun ? 'on' : 'off'} />
                        Сухой ход
                    </div>
                </td>
                <td className="second-col">
                    <div className="indicator-container">
                        <Indicator state={flowError ? 'on' : 'off'} />
                        Отсутствие потока
                    </div>
                </td>
            </tr>
            <tr className="indicator-row">
                <td colspan="2" className="full-width">
                    <div className="indicator-container alarm-pch">
                        <Indicator state={driveFault ? 'on' : 'off'} />
                        Авария ПЧ
                    </div>
                    <div className="alarm-details">{faultDetails}</div>
                </td>
            </tr>
        </tbody>
    </table>
    <BtnStartStop pumpNumber={pumpNumber} />
    </div>
    )
}